// extracted by mini-css-extract-plugin
export default {"buyPop":"welcomeBonusPop_buyPop__FNkj7","price":"welcomeBonusPop_price__rup+c"};